import * as actions from './login.actions'
import { Action, Reducer } from 'src/framework'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, Option, some, option } from 'fp-ts/lib/Option'
import { State } from 'src/app.store'
import { Status } from '@yobora/models/rights'

export interface UserIdentity {
  companyId: string
  initials: string
  userName: string
  token: string
  rights: Status[]
}

export interface LoginState {
  identity: Option<UserIdentity>
}
export const getIdentity = (state: State) => state.login.identity
export const getToken = (state: State) => option.map(getIdentity(state), id => id.token)

export const identityLense = Lens.fromProp<LoginState>()('identity')

export const initialLoginState: LoginState = { identity: none }

export const sameState: (s: LoginState) => LoginState = identity

export const loginReducer: Reducer<Action<any>, LoginState> = actions.loginActions.match({
  Login: _action => sameState,
  Logout: _action => identityLense.set(none),
  LoginSuccess: ({ companyId, initials, userName, token, rights }) =>
    identityLense.set(some({ companyId, initials, userName, token, rights })),
  LoginFailure: _action => sameState,
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/users-components/login/login.reducer.ts